import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs'
import { mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { PushNotificationsService } from './push.notification.service';
import { UserService } from './user.service';
/**
 * @ignore
 */
@Injectable()

export class MessagingService {
  currentMessage = new BehaviorSubject(null);
  user;
  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private userService: UserService,
    private authService: AuthService,
    private _notificationService: PushNotificationsService) {
  }

  requestPermission() {
    if (!("Notification" in window)) {
      console.log("This browser does not support desktop notification");
    }
    else if (Notification.permission === "granted") {
      // If it's okay let's create a notification
      console.log('notification allowed')
    }

    if (!this.isWindowControllerSupported()) {
      console.log('something is wrong.');
      return;
    }

    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        console.log(token);
        this.authService.LoggedinUser.subscribe(user => this.user = user);
        if (token) {
          let body = {
            meta: {}
          };

          body['deviceId'] = token;

          let userAgent = navigator.userAgent;
          let browserName;

          if (userAgent.match(/chrome|chromium|crios/i)) {
            browserName = "chrome";
          } else if (userAgent.match(/firefox|fxios/i)) {
            browserName = "firefox";
          } else if (userAgent.match(/safari/i)) {
            browserName = "safari";
          } else if (userAgent.match(/opr\//i)) {
            browserName = "opera";
          } else if (userAgent.match(/edg/i)) {
            browserName = "edge";
          } else {
            browserName = "No browser detection";
          }

          body.meta['manufacturer'] = browserName;

          this.userService.subscribeDevice(this.user.id, body).subscribe();
        }
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }

  isWindowControllerSupported(): boolean {
    return (
      navigator.cookieEnabled &&
      'serviceWorker' in navigator &&
      'PushManager' in window &&
      'Notification' in window &&
      'fetch' in window &&
      ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
      PushSubscription.prototype.hasOwnProperty('getKey')
    );
  }

  receiveMessage() {
    this.angularFireMessaging.onMessage(payload => {
      console.log("onMessage: ", payload);

      // const NotificationOptions = {
      //   body: 'Image has finished processing.',
      //   data: 'data',
      //   icon: './assets/img/logo.png'
      // }

      // navigator.serviceWorker.getRegistration('/firebase-cloud-messaging-push-scope').then(registration => {
      //   registration.showNotification(
      //     'Image processing',
      //     NotificationOptions
      //   )
      // });

      let isNormalNotification =
        !!payload.data.languageContents &&
        !!payload.data.contentType;

      !isNormalNotification && this.currentMessage.next(payload);
    }).catch(err => {
      console.log('This browser doesn\'t support the API\'s required to use the firebase SDK.');
    });
  }

  deleteToken() {
    this.angularFireMessaging.getToken
      .pipe(mergeMap(token => this.angularFireMessaging.deleteToken(token)))
      .subscribe(
        (token) => { console.log('Token deleted!'); },
      );
  }

  notify() {
    const data: Array<any> = [];
    data.push({
      title: 'Checker Panel',
      alertContent: 'New Image for process'
    });
    this._notificationService.generateNotification(data);
  }
}